import React from 'react'
import Header from '../layout/Header';
import { Link } from 'react-router-dom';
import shopBan1Image from '../../images/shop-ban1.png';
import shopBan2Image from '../../images/shop-ban2.png';
import shopBan3Image from '../../images/shop-ban3.jpg';
import shopIcon1 from '../../images/shop-icon1.png';
import shopIcon2 from '../../images/shop-icon2.png';
import shopIcon3 from '../../images/shop-icon3.png';
import shopBan4Image from '../../images/shop-ban4.jpg';
import shopCard1 from '../../images/shop-card1.jpg';
import shopCard2 from '../../images/shop-card2.jpg';
import shopIcon4 from '../../images/shop-icon4.png';
import shopIcon5 from '../../images/shop-icon5.png';
import shopIcon6 from '../../images/shop-icon6.png';
import shopIcon7 from '../../images/shop-icon7.png';
import shopIcon8 from '../../images/shop-icon8.png';
import shopIcon9 from '../../images/shop-icon9.png';
import shopIcon10 from '../../images/shop-icon10.png';
import shopIcon11 from '../../images/shop-icon11.png';
import shopIcon12 from '../../images/shop-icon12.png';
import shopCardImage1 from '../../images/shop-cardimg1.png';
import shopCardImage2 from '../../images/shop-cardimg2.png';
import shopCardImage3 from '../../images/shop-cardimg3.png';
import shopCardImage4 from '../../images/shop-cardimg4.png';
import shopBan5Image from '../../images/shop-ban5.jpg';
import UpdateVyldfyreVideo from '../../images/UpdateVyldfyreVideo.mp4'; 
function Shop() {
  return (
    <div>
        <Header />
         <section id="shopvyldcard">
        <div className="container">
          <div className="row my-5">
            <div className="col-md-7 mb-4 text-start">
              <p className="yellowtext mb-1">#StartSmallGrowBig</p>
              <h1>
                NFC Business Card
                <br /> with VYLDFYRE
              </h1>
              <p className="w-75 mb-4 f20">
                Introducing VYLDFYRE NFC Card – a&nbsp;free service&nbsp;that adds
                an online extension to a single business card you keep. Smart
                scanning technology instantly brings customers to profile, website
                website, mini store and everything else that makes your business go.
              </p>
              <p>
                <Link to="/vyldfyre-card" className="regbtn ">
                  Get started for FREE
                </Link>{" "}
              </p>
            </div>
            <div className="col-md-5 text-center">
              <div className="vyldcard">
                <img
                  src={shopBan1Image}
                  className="img-fluid"
                  alt=""
                />
                <div className="mboncard">
                  <img
                    src={shopBan2Image}
                    className="img-fluid w-100"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row my-5 text-start">
            <h2 className="mb-4 mt-5 pt-5 mbmtp">What is VYLDFYRE NFC?</h2>
            <video width="600" controls>
        <source src={UpdateVyldfyreVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
          </div>
          <div className="row text-start">
            <h2 className="mb-4">How VYLDFYRE NFC works?</h2>
            <div className="col-md-4 mb-4">
              <p className="mb-4">
                {" "}
                <img src={shopIcon1} alt="" />
              </p>
              <h6 className="mb-3">Your visiting card</h6>
              <p className="f16 w-75">
                Put your contact info directly onto customers' devices with your NFC
                smart visiting card.
              </p>
            </div>
            <div className="col-md-4 mb-4">
              <p className="mb-4">
                {" "}
                <img src={shopIcon2} alt="" />
              </p>
              <h6 className="mb-3">Your customers</h6>
              <p className="f16 w-75">
                People hold their phone over the NFC business card to activate the
                phone’s built-in scanning technology.
              </p>
            </div>
            <div className="col-md-4 mb-4">
              <p className="mb-4">
                {" "}
                <img src={shopIcon3} alt="" />
              </p>
              <h6 className="mb-3">Your VYLDFYRE profile</h6>
              <p className="f16 w-75">
                Customers go to your new online experience, which we’ll help you
                create and edit –&nbsp;free of charge.
              </p>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-md-6 mb-4">
              <img
                src={shopBan4Image}
                className="img-fluid w-100"
                alt=""
              />
            </div>
            <div className="col-md-6 text-start">
              <h6 className="mb-3">VYLDFYRE NFC</h6>
              <p className="f16 mb-3">
                Customers use their phone to scan a chip embedded in your smart
                contactless business card. Their phone gets a notification with the
                link to your VistaConnect experience.
              </p>
              <p className="mb-3 f16">NFC visiting card features</p>
              <ul className="ps-4 mb-4">
                <li>Durable plastic material</li>
                <li>Subtle &amp; elegant design</li>
                <li>Increasingly popular</li>
              </ul>
              <p className="mb-5">1 starting at&nbsp;₹750.00</p>
              <p>
                <Link href="#" className="regbtn ">
                  Get started for FREE
                </Link>{" "}
              </p>
            </div>
          </div>
          <div className="row my-5 text-start">
            <h2 className="mb-4">
              Make a stronger connection with potential customers.
            </h2>
            <div className="col-md-4 mb-5">
              <img
                src={shopCard1}
                className="img-fluid w-100"
                alt=""
              />
              <p className="mt-3 f20">Professional Profile</p>
            </div>
            <div className="col-md-4 mb-5">
              <img
                src={shopCard2}
                className="img-fluid w-100"
                alt=""
              />
              <p className="mt-3 f20">Photo Gallery</p>
            </div>
            <div className="col-md-4">
              <img
                src={shopCard2}
                className="img-fluid w-100"
                alt=""
              />
              <p className="mt-3 f20">Video</p>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon4} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">Business info</span>
                    <br />
                    Important info about you or your business
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon5} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">"Call now" button</span>
                    <br />A tappable button to call you
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon6} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">"Add Contact" button</span>
                    <br />A tappable button to add you as contact
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon7} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">Hours</span>
                    <br />
                    Your schedule or hours of operation
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon8} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">Social Links</span>
                    <br />
                    Links to your social media
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon9} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">Video</span>
                    <br />
                    Embedded videos from YouTube or Vimeo
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon10} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">Website Link</span>
                    <br />A link to your existing site
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon11} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">Photo Gallery</span>
                    <br />A gallery of your uploaded images
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <img src={shopIcon12} alt="" />
                </div>
                <div className="col-10 text-start">
                  <p>
                    <span className="f16">Custom Link</span>
                    <br />A link to any site you want
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row my-5 text-start">
            <h2 className="mb-3">VYLDFYRE NFC Card takes minutes to set up.</h2>
            <div className="col-md-3 mb-5">
              <div className="card mb-3">
                <img src={shopCardImage1} alt="" />
              </div>
              <p>
                <span className="f16">01. Create your smart visiting card</span>
                <br />
                Customize one of our templates with your own text and images.
              </p>
            </div>
            <div className="col-md-3 mb-5">
              <div className="card mb-3">
                <img src={shopCardImage2} alt="" />
              </div>
              <p>
                <span className="f16">02. Create your online experience</span>
                <br />
                Customize one of our templates with your own text and images.
              </p>
            </div>
            <div className="col-md-3 mb-5">
              <div className="card mb-3">
                <img src={shopCardImage3} alt="" />
              </div>
              <p>
                <span className="f16">03. Place your order</span>
                <br />
                Customize one of our templates with your own text and images.
              </p>
            </div>
            <div className="col-md-3">
              <div className="card mb-3">
                <img src={shopCardImage4} alt="" />
              </div>
              <p>
                <span className="f16">04. Activate VistaConnect</span>
                <br />
                Customize one of our templates with your own text and images.
              </p>
            </div>
          </div>
          <div className="row text-start">
            <div className="col-md-5 mt-5">
              <h6 className="mb-4">
                Create a smart business card that can keep up with you.
              </h6>
              <p className="f16">
                Your business moves fast, but your custom NFC digital business card
                and online experience keep all your customers, connections and
                partners up to date. You can update your site anytime with a simple,
                easy-to-use menu. Daily specials. Seasonal sales. Additional contact
                info or a brand new location. You'll never need to reprint your
                cards with VistaConnect — it's just click, click, done. For larger
                quantities, contact us and we’ll help you place your order.
              </p>
            </div>
            <div className="col-md-7">
              <img
                src={shopBan5Image}
                className="img-fluid w-100"
                alt=""
              />
            </div>
            <div className="col-md-12 greybox">
              <h1>
                Get started with
                <br /> VYLDFYRE for free
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section id="faqs" className="mb-5">
        <div className="container text-start">
          <div className="row mt-5">
            <h2 className="mb-4 mt-5">Frequently Asked Questions</h2>
          </div>
          <div className="row">
            <div className="col-md-12 mb-5">
              <div className="accordion accordion-flush" id="accordionFlushExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button
                      className="accordion-button collapsed position-relative"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      Can I create or edit my online experience after I buy my NFC
                      visiting cards?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Yes, you don’t need to build the online experience before
                      completing your purchase. You can use our convenient
                      builder/editor to create, update or edit your VistaConnect
                      experience whenever you want. Go to&nbsp;My Account&nbsp;and
                      select&nbsp;My Digital Marketing&nbsp;to access these features
                      on the VistaPrint website.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button
                      className="accordion-button collapsed position-relative"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      What is a NFC business card? How do customers use it?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Near Field Communication (NFC) is contactless transfer
                      technology like Bluetooth and Wi-Fi. It allows devices to send
                      and receive bits of data or information. Hold the card to a
                      smartphone to enable or activate the NFC built into your
                      digital visiting card.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingThree">
                    <button
                      className="accordion-button collapsed position-relative"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      Why are NFC smart visiting cards more expensive?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      We use a thicker, 0.8mm (0.08 cm) durable plastic for NFC
                      digital business cards, which helps protect the built-in
                      technology and gives the cards better overall durability. We
                      charge our regular price for this type of paper – no extra
                      charge for the NFC functionality.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingfour">
                    <button
                      className="accordion-button collapsed position-relative"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapsefour"
                      aria-expanded="false"
                      aria-controls="flush-collapsefour"
                    >
                      Do I need a website to use scannable visiting cards with
                      VistaConnect?
                    </button>
                  </h2>
                  <div
                    id="flush-collapsefour"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingfour"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      No – you don’t need much knowledge about the Internet. We’ll
                      help you create and manage your new online experience for
                      customers. See above for more information on what you can do
                      with VistaConnect.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingfive">
                    <button
                      className="accordion-button collapsed position-relative"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapsefive"
                      aria-expanded="false"
                      aria-controls="flush-collapsefive"
                    >
                      Can I connect my scannable visiting cards to my existing or
                      other websites?
                    </button>
                  </h2>
                  <div
                    id="flush-collapsefive"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingfive"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Absolutely. You can link to your existing website, related
                      websites, social media profiles and more.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingsix">
                    <button
                      className="accordion-button collapsed position-relative"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapsesix"
                      aria-expanded="false"
                      aria-controls="flush-collapsesix"
                    >
                      Can I add features like appointment scheduling or links to my
                      online stores at Etsy or Amazon?
                    </button>
                  </h2>
                  <div
                    id="flush-collapsesix"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingsix"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Yes, you can link your existing Etsy, Amazon shop links as a
                      URL as well as appointment booking services links.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingseven">
                    <button
                      className="accordion-button collapsed position-relative"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseseven"
                      aria-expanded="false"
                      aria-controls="flush-collapseseven"
                    >
                      Where can I see how to create my VistaConnect online
                      experience?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseseven"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingseven"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      After you finish designing your NFC visiting card, we'll take
                      you to our VistaConnect studio, where you can customize and
                      preview the online experience you'll be linking to. Please
                      note that the QR codes for your cards will be auto-generated.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingeight">
                    <button
                      className="accordion-button collapsed position-relative"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseeight"
                      aria-expanded="false"
                      aria-controls="flush-collapseeight"
                    >
                      Additional Information
                    </button>
                  </h2>
                  <div
                    id="flush-collapseeight"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingeight"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Generic Name: Visiting Cards
                      <br />
                      Corners: Rounded
                      <br />
                      Shape: Rectangle
                      <br />
                      Product Dimensions (lw):8.5 cm x 5.4 cm
                      <br />
                      Package Dimensions (lwh):9.5 cm x 5.5 cm x 5.3 cm
                      <br />
                      Item Weight:45 g<br />
                      Color Name:White
                      <br />
                      Material:PVC 0.8 mm thickness card
                      <br />
                      Included Components: NFC Chip embedded Visiting Card
                      <br />
                      Name and Address of the Manufacturer: Octonion Design
                      Solutions LLP, 3-1-208/7, Sowbhagya Nagar, LB Nagar, Hyderabad
                      - 500074. India.
                      <br />
                      Name and Address of the Packer:Octonion Design Solutions LLP,
                      3-1-208/7, Sowbhagya Nagar, LB Nagar, Hyderabad - 500074.
                      India.
                      <br />
                      Delivery and Shipping: Estimated Delivery/Arrival time will be
                      calculated at Shipping Stage
                      <br />
                      Terms of Returns, Refund &amp; Grievance Officer details:
                      Click Here <br />
                      Registered Office and Branch Locations: Hyderabad
                      <br />
                      Legal Name of Entity: Octonion Design Solutions LLP
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Shop